import { DecisionProfile } from './DecisionProfile';
import { OnboardingProfile } from './OnboardingProfile';
import { getProfileTitle } from './profileStages';
import { CustomerRow } from '../../CustomersV2.types';
import { InfoSheet } from '../InfoSheet/InfoSheet';

export const CustomerProfileModal = ({
  row,
  onClose,
}: {
  row: CustomerRow | null;
  onClose: () => void;
}) => {
  if (!row) return null;

  const isDecisionReady = row.application_stage.value === 'complete';

  return (
    <InfoSheet
      isOpen
      onClose={onClose}
      title={getProfileTitle(row)}
      closeLabel="Close customer profile"
    >
      <div className="p-xl">
        {isDecisionReady ? (
          <DecisionProfile row={row} />
        ) : (
          <OnboardingProfile row={row} />
        )}
      </div>
    </InfoSheet>
  );
};
